import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])
  const toastsEnabled = ref(JSON.parse(localStorage.getItem('toastsEnabled') ?? 'true'))
  let toastId = 0

  const setToastsEnabled = (enabled) => {
    toastsEnabled.value = enabled
    localStorage.setItem('toastsEnabled', JSON.stringify(enabled))
  }

  const addToast = (message, type = 'info', duration = 4000) => {
    if (!toastsEnabled.value) return null
    
    const id = ++toastId
    const toast = {
      id,
      message,
      type, // 'success', 'error', 'warning', 'info'
      duration
    }
    
    toasts.value.push(toast)
    
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }
    
    return id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAll = () => {
    toasts.value = []
  }

  // Convenience methods
  const success = (message, duration = 4000) => addToast(message, 'success', duration)
  const error = (message, duration = 6000) => addToast(message, 'error', duration)
  const warning = (message, duration = 5000) => addToast(message, 'warning', duration)
  const info = (message, duration = 4000) => addToast(message, 'info', duration)

  const $reset = () => {
    toasts.value = []
    toastsEnabled.value = true
    toastId = 0
    localStorage.removeItem('toastsEnabled')
  }

  return {
    toasts,
    toastsEnabled,
    setToastsEnabled,
    addToast,
    removeToast,
    clearAll,
    success,
    error,
    warning,
    info,
    $reset
  }
})